import React from 'react';
import MarketCapFilter from './MarketCapFilter';
import SectorsFilter from './SectorsFilter';
import TypeFilter from './TypeFilter';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const FilterHeaderIcons = ({ activeFilters, onApplyFilters }) => {
  return (
    <div className="flex items-center gap-2">
      <div
        data-tooltip-id="filter-tooltip"
        data-tooltip-content="Filter by Security Type"
        data-tooltip-place="top"
      >
        <TypeFilter
          activeFilters={activeFilters?.types}
          onApplyFilters={onApplyFilters}
        />
      </div>
      <div
        data-tooltip-id="filter-tooltip"
        data-tooltip-content="Filter by Market Cap ($)"
        data-tooltip-place="top"
      >
        <MarketCapFilter
          activeFilters={activeFilters?.marketCap}
          onApplyFilters={onApplyFilters}
        />
      </div>
      <div
        data-tooltip-id="filter-tooltip"
        data-tooltip-content="Filter by Sector"
        data-tooltip-place="top"
      >
        <SectorsFilter
          activeFilters={activeFilters?.sectors}
          onApplyFilters={onApplyFilters}
        />
      </div>
      <Tooltip id="filter-tooltip" place="top" offset={5} />
    </div>
  );
};

FilterHeaderIcons.propTypes = {
  activeFilters: PropTypes.shape({
    types: PropTypes.arrayOf(PropTypes.string),
    marketCap: PropTypes.arrayOf(PropTypes.string),
    sectors: PropTypes.arrayOf(PropTypes.string)
  }),
  onApplyFilters: PropTypes.func.isRequired
};

export default FilterHeaderIcons;
